//  import { Map as ImmutableMap } from 'immutable';
import { resourceStoreTypes, resourceUpserters } from 'app-components/flux/core';
import { handleActions } from 'redux-actions';

import * as actions from './transferBalanceActions';

const transferBalanceReducer = handleActions(
  {
    [actions.getTransferBalance]: (state) => state.merge({ isLoading: true }),
    [actions.getTransferBalanceSuccess]: (state, action) => resourceUpserters.upsertResource(state, action.payload),
    [actions.getTransferBalanceFailure]: (state, { payload: error }) =>
      resourceUpserters.completeWithError(state, error),
  },
  resourceStoreTypes.mkQcsSyncResourceStore(),
);

export const TRANSFER_BALANCE_REDUCER_KEY = 'transferBalanceStore';
export default transferBalanceReducer;
